//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { PageUtils } from "./helpers/page-utils";
const _debounce = require('lodash.debounce');

window.Swiper = Swiper;
window.Navigation = Navigation;
window.Pagination = Pagination;

function closeLightBox(lightbox) {
    lightbox.dataset.visible = 'false';
    PageUtils.bodyLockToggleOff();
    setTimeout(() => { lightbox.dataset.hidden = 'true'; }, 300);
}

function openLightBox(lightbox) {
    lightbox.dataset.hidden = 'false';
    PageUtils.bodyLockToggleOn();
    document.getElementById('siteHeader').dataset.visible = 'false';
    document.body.dataset.navVisible = 'false';
    setTimeout(() => { lightbox.dataset.visible = 'true'; }, 50);
}

function updateNavButtons(swiper, prevEl, nextEl) {
    const prevButton = document.querySelector(prevEl);
    const nextButton = document.querySelector(nextEl);

    if (prevButton && nextButton) {
        prevButton.disabled = swiper.isBeginning;
        nextButton.disabled = swiper.isEnd;

        // Optionally, add/remove opacity styles for better UX
        prevButton.classList.toggle('opacity-50', swiper.isBeginning);
        prevButton.classList.toggle('pointer-events-none', swiper.isBeginning);

        nextButton.classList.toggle('opacity-50', swiper.isEnd);
        nextButton.classList.toggle('pointer-events-none', swiper.isEnd);
    }
}

function documentKeydownHandler(event, lightbox, swiper) {
    if (!lightbox.classList.contains('hidden')) {
        if (event.key === 'Escape') closeLightBox(lightbox);
        else if (event.key === 'ArrowRight') swiper.slideNext();
        else if (event.key === 'ArrowLeft') swiper.slidePrev();
    }
}

window.addEventListener('load', () => {
    const swiperElementsPresent = !!document.querySelector('.swiper');

    const galleryPanel = document.querySelectorAll('.gallery-panel');
    const cardPanel = document.querySelectorAll('.card-panel-slider');
    const testimonialSliderPanel = document.querySelectorAll('.testimonial-panel-slider');
    const testimonialFaderPanel = document.querySelectorAll('.testimonial-panel-fader');

    if (swiperElementsPresent) {

        // START CARD PANEL SLIDER
        for (const panel of cardPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="card-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="card-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="card-slider-${swiperIndex}"]`;

                const cardSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="card-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1280: {
                            slidesPerView: 3,
                            spaceBetween: 32,
                        },
                    },
                });

                cardSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(cardSwiper, prevEl, nextEl);
                });
                updateNavButtons(cardSwiper, prevEl, nextEl);
            }
        }
        // END CARD PANEL SLIDER

        // START GALLERY PANEL SLIDER
        for (const panel of galleryPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="gallery-slider"]');

            if (swiperElement) {
                const galleryThumbnails = swiperElement.querySelectorAll('.gallery-panel-image');
                const lightbox = panel.querySelector('[data-lightbox="gallery-panel"]');
                const swiperElementLightbox = panel.querySelector('.swiper[data-swiper-type="gallery-lightbox-slider"]');

                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const destroySwiperDesktop = swiperElement.dataset.destroySwiperDesktop === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="gallery-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="gallery-slider-${swiperIndex}"]`;

                let gallerySwiper;
                let galleryLightboxSwiper;

                function initSwipers() {
                    if (window.innerWidth >= 1024 && destroySwiperDesktop) {
                        if (gallerySwiper) {
                            gallerySwiper.destroy(true, true);
                            gallerySwiper = null;
                        }
                    } else {
                        if (!gallerySwiper) {
                            gallerySwiper = new Swiper(swiperElement, {
                                loop: false,
                                speed: 350,
                                direction: 'horizontal',
                                allowTouchMove: true,
                                resistanceRatio: 0,
                                autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,
                                slidesPerView: mobileSlidePerPage,
                                slidesPerGroup: 1,
                                spaceBetween: 24,
                                pagination: {
                                    el: `[data-swiper-pagination="gallery-slider-${swiperIndex}"]`,
                                    clickable: true,
                                    renderBullet: function (index, className) {
                                        return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                                    },
                                },
                                navigation: { nextEl: nextEl, prevEl: prevEl },
                                breakpoints: {
                                    640: { slidesPerView: mobileSlidePerPage, spaceBetween: 24 },
                                    768: { slidesPerView: tabletSlidePerPage, spaceBetween: 24 },
                                    1280: { slidesPerView: 3, spaceBetween: 32 },
                                },
                            });
                        }
                    }
                }

                if (!!lightbox && !!swiperElementLightbox) {
                    galleryLightboxSwiper = new Swiper(swiperElementLightbox, {
                        effect: 'fade',
                        fadeEffect: { crossFade: true },
                        speed: 750,
                        loop: true,
                        centeredSlides: true,
                        resistanceRatio: 0,
                        autoplay: autoplay ? { delay: 10000, disableOnInteraction: false } : false,
                        allowTouchMove: true,
                    });
                }

                initSwipers();

                const handleResize = _debounce(() => {
                    initSwipers();
                }, 300);

                window.addEventListener("resize", handleResize);

                if (lightbox) {
                    const lightboxBackdrop = lightbox.querySelector('[data-lightbox-backdrop]');
                    const lightboxClose = lightbox.querySelector('[data-lightbox-close]');

                    if (lightboxBackdrop) {
                        lightboxBackdrop.addEventListener('click', () => closeLightBox(lightbox));
                    }
                    if (lightboxClose) {
                        lightboxClose.addEventListener('click', () => closeLightBox(lightbox));
                    }
                }

                let syncing = false;

                if (galleryLightboxSwiper && gallerySwiper) {
                    galleryLightboxSwiper.on('slideChange', function () {
                        if (!syncing) {
                            syncing = true;
                            gallerySwiper.slideToLoop(galleryLightboxSwiper.realIndex, 0, false);
                            syncing = false;
                        }
                    });
                }

                galleryThumbnails.forEach(thumbnail => {
                    thumbnail.addEventListener('click', () => {
                        const slideIndex = parseInt(thumbnail.dataset.slide);
                        galleryLightboxSwiper.slideToLoop(slideIndex, 0);
                        openLightBox(lightbox);
                    });
                });
            }
        }
        // END GALLERY PANEL SLIDER

        // START TESTIMONIAL PANEL SLIDER
        for (const panel of testimonialSliderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-slider"]');

            if (swiperElement) {
                const mobileSlidePerPage = 1.1;
                const tabletSlidePerPage = 2.1;
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-slider-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-slider-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    loop: false,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: mobileSlidePerPage,
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-slider-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: mobileSlidePerPage,
                            spaceBetween: 24,
                        },
                        768: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 24,
                        },
                        1024: {
                            slidesPerView: tabletSlidePerPage,
                            spaceBetween: 32,
                        },
                        1450: {
                            slidesPerView: 2,
                            spaceBetween: 32,
                        },
                    },
                });

                // Function to toggle navigation button visibility
                testimonialSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(testimonialSwiper, prevEl, nextEl);
                });

                updateNavButtons(testimonialSwiper, prevEl, nextEl);
            }
        }
        // END TESTIMONIAL PANEL SLIDER

        // START TESTIMONIAL PANEL FADER
        for (const panel of testimonialFaderPanel) {
            const swiperElement = panel.querySelector('.swiper[data-swiper-type="testimonial-fader"]');

            if (swiperElement) {
                const paginationBackgroundColor = swiperElement.dataset.paginationBackgroundColor;
                const paginationBorderColor = swiperElement.dataset.paginationBorderColor;
                const autoplay = swiperElement.dataset.autoPlay === "true";
                const swiperIndex = swiperElement.dataset.swiperIndex;
                const nextEl = `button[data-swiper-go-next="testimonial-fader-${swiperIndex}"]`;
                const prevEl = `button[data-swiper-go-prev="testimonial-fader-${swiperIndex}"]`;

                const testimonialSwiper = new Swiper(swiperElement, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    loop: true,
                    speed: 750,
                    direction: 'horizontal',
                    allowTouchMove: true,
                    autoplay: autoplay ?
                        {
                            delay: 10000,
                            disableOnInteraction: false
                        } : false,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    pagination: {
                        el: `[data-swiper-pagination="testimonial-fader-${swiperIndex}"]`,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return `<span class="${className} rounded-full w-2 h-2 cursor-pointer opacity-50 hover:opacity-75 hover:scale-125 origin-center transition-all duration-150 ease-in-out border ${paginationBackgroundColor} ${paginationBorderColor} [&.swiper-pagination-bullet-active]:!opacity-100 [&.swiper-pagination-bullet-active]:!scale-100"></span>`;
                        },
                    },
                    navigation: {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        },
                        1024: {
                            slidesPerView: 1,
                        },
                        1450: {
                            slidesPerView: 1,
                        },
                    },
                });

                // Function to toggle navigation button visibility
                testimonialSwiper.on('reachBeginning reachEnd slideChange', function () {
                    updateNavButtons(testimonialSwiper, prevEl, nextEl);
                });

                updateNavButtons(testimonialSwiper, prevEl, nextEl);
            }
        }
        // END TESTIMONIAL PANEL FADER

    }
});
